
// src/pages/admin/PlantAdmin.js
import React, { useEffect, useState } from "react";
import { FaEdit, FaPlus } from "react-icons/fa";
import FileUploader from "../../components/fileManager/FileUploader";
import { useLoading } from "../../components/LoadingProvider";
import LanguageDropdown from "../../components/LanguageDropdown";
import LanguageFlag from "../../components/LanguageFlag";

import {
  createPlant,
  updatePlant,
  getAllPlantGroups,
  // deletePlant,
  getAllPlants,
} //from "../../services/plants/PlantService";
from "../../services/plants/adminPlantsService";

// import { getAllPlants } from "../../services/plants/publicPlantsService";

import Util  from '../../components/Util'

import { useTranslation } from "react-i18next";

const PlantAdmin = () => {
  const [plants, setPlants] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    latinName: "",
    description: "",
    aparatEmbedUrl: "",
    isActive: true,
    image: "",
    language: "fa",
    watering: [],
    temperature: {
      min_celsius: '',
      max_celsius: ''
    },

  });
  const [editId, setEditId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { t, i18n } = useTranslation();
  const { toast } = useLoading();
  const [groups, setGroups] = useState([]);
  
  const BASE_URL = process.env.REACT_APP_BASE_URL;


  
     const fetchGroups = async () => {
        try {
          const res = await getAllPlantGroups();
          setGroups(res); // depends on HTTP wrapper
        } catch (err) {
          console.error(err);
    
          const txt = t('console.planetgroup.messages.fetch_group_catch_error');
    
    
          setError(txt);
          toast.error(txt);
    
        }
      };

  useEffect(() => {
    fetchGroups();

    fetchPlants();
  }, []);

  const fetchPlants = async () => {
    try {
      const res = await getAllPlants();
      setPlants(res);
    } catch (err) {
      setError(t("console.plant.error_submit"));
      toast.error(t("console.plant.error_submit"));
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      latinName: "",
      description: "",
      aparatEmbedUrl: "",
      isActive: true,
      image: "",
      language: "",
      watering: [],
      temperature: {
          min_celsius: '',
          max_celsius: ''
      },

    });
    setIsEditMode(false);
    setEditId(null);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        // images: [{ url: formData.image, title: formData.name }]
        // images: formData.images //[{ url: formData.image, title: formData.name }]
      };

      if(payload.watering.length < 1)
      {
          toast.error(t("console.plant.error_submit_watering_validation"));
          return;
      }
        console.log('payload ::: ',payload);


      if (editId) {
        const resp = await updatePlant(editId, payload);
     

        if(resp.hasError)
        {
          toast.error(resp.message);
          return;
        }

        toast.success(t("console.plant.success_update"));
      } else {
        const resp =  await createPlant(payload);
        if(resp.hasError)
        {
          toast.error(resp.message);
          return;
        }
       

        toast.success(t("console.plant.success_create"));
      }
      resetForm();
      fetchPlants();
    } catch (err) {
      console.error(err);
      toast.error(t("console.plant.error_submit"));
    }
  };

  const handleEdit = (plant) => {
    console.log('handleEdit' , plant)
    setFormData({
      name: plant.name,
      latinName: plant.latinName,
      description: plant.description,
      aparatEmbedUrl: plant.aparatEmbedUrl,
      isActive: plant.isActive,
      image: plant.images?.[0]?.type || "",
      language: plant.language,
      watering: wateringMapper(plant.watering),
      temperature: {
        min_celsius: plant.temperature?.min_celsius || '',
        max_celsius: plant.temperature?.max_celsius || '',
      },

    });
    setEditId(plant._id);
    setIsEditMode(true);
  };


  function wateringMapper(dbWateringList){
    // console.log('input :: ',dbWateringList)

    return dbWateringList || [];
  }


  function ExpandableDescription({ text }) {
      const [expanded, setExpanded] = useState(false);
      const threshold = 120;
      const isLong = text.length > threshold;

      return (
        <>
          {expanded || !isLong ? text : `${text.slice(0, threshold)}...`}
          {isLong && (
            <button onClick={() => setExpanded(!expanded)} className="badge bg-warning">
              {expanded ? 'Less' : 'More'}
            </button>
          )}
        </>
      );
    }



      const handleWateringChange = (index, key, value) => {
      const updated = [...formData.watering];
      updated[index] = { ...updated[index], [key]: Util.toEnglishDigits(value) };


      console.log('handleWateringChange' , updated)


      setFormData((prev) => ({ ...prev, watering: updated }));
    };

    const handleNestedChange = (index, parentKey, key, value) => {
      const updated = [...formData.watering];
      updated[index] = {
        ...updated[index],
        [parentKey]: {
          ...(updated[index][parentKey] || {}),
          [key]:Util.toEnglishDigits( value ),
        },
      };

      console.log('handleNestedChange' , updated)

      setFormData((prev) => ({ ...prev, watering: updated }));
    };

    const handleAmountChange = (index, val) => {
      try {
        
        handleWateringChange(index, "amountPerTime", Util.toEnglishDigits(val));
      } catch (err) {
        console.error("Invalid JSON for amountPerTime");
      }
    };

    const addWatering = () => {
      setFormData((prev) => ({
        ...prev,
        watering: [
          ...prev.watering,
          {
            frequencyType: "daily",
            intervalDays: null,
            timesPerDay: 1,
            amountPerTime: 0,
            season: "spring",
            potSize: "medium",
            requiredLight: { duration_hours: "", type: "INDIRECT_MEDIUM" },
          },
        ],
      }));
    };

    const removeWatering = (index) => {
      const updated = [...formData.watering];
      updated.splice(index, 1);
      setFormData((prev) => ({ ...prev, watering: updated }));
    };


  return (
    <div className="container py-5">
      <h2 className="mb-4 text-center fw-bold">{t("console.plant.title")}</h2>

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <div className="card mb-5 shadow-sm">
        <div className="card-header">
          {isEditMode ? t("console.plant.card_header_edit") : t("console.plant.card_header_add")}
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-3">
              <LanguageDropdown
                defaultValue={formData.language}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, language: value }))
                }
              />
            </div>





          <div className="col-md-3">
                <label className="form-label">  { t('console.plant.form_table_title') }  </label>
                <select
                  className="form-select"
                  name="group"
                  onChange={handleChange}
                >
                  <option value="" disabled> { t('components.default_dropdown.dropdown_label') }   </option>
                  {groups.map((obj) => (
                    <option key={obj._id} value={obj._id}>
                      {obj.name}  
                    </option>
                  ))}
                </select>
              </div>




            <div className="col-md-3">
              <label className="form-label">{t("console.plant.form_name")}</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">{t("console.plant.form_latinName")} </label>
              <input
                type="text"
                name="latinName"
                className="form-control"
                value={formData.latinName}
                onChange={handleChange}
              />
            </div>


            <div className="col-md-3">
              <label className="form-label"> {t("console.plant.form_min_celsius")} (°C)</label>
              <input
                type="number"
                name="min_celsius"
                className="form-control"
                value={formData.temperature?.min_celsius || ''}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    temperature: {
                      ...prev.temperature,
                      min_celsius: Util.toEnglishDigits( e.target.value ),
                    },
                  }))
                }
              />
            </div>

            <div className="col-md-3">
              <label className="form-label"> {t("console.plant.formـmax_celsius")} (°C)</label>
              <input
                type="number"
                name="max_celsius"
                className="form-control"
                value={formData.temperature?.max_celsius || ''}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    temperature: {
                      ...prev.temperature,
                      max_celsius: Util.toEnglishDigits(e.target.value),
                    },
                  }))
                }
              />
            </div>



            <div className="col-md-6">
              <label className="form-label">{t("console.plant.form_aparat")}</label>
              {/* <input
                type="text"
                name="aparatEmbedUrl"
                className="form-control"
                value={formData.aparatEmbedUrl}
                onChange={handleChange}
              /> */}

               <textarea
                name="aparatEmbedUrl"
                className="form-control"
                placeholder="اشتراک > دریافت کد امبد > کد iframe"
                rows={3}
                value={formData.aparatEmbedUrl}
                onChange={handleChange}
              />


            </div>
            <div className="col-md-6">
              <label className="form-label">{t("console.plant.form_upload_image_label")}</label>
              <FileUploader
                defaultImageUrl={formData.image}

                onUpload={(url) =>
                setFormData((prev) => ({
                  ...prev,
                  images: [
                    ...(prev.images || []),
                    {
                      title: '-', // or set a default like 'Untitled' if you prefer
                      url: url,
                    },
                  ],
                }))
              }
                // onUpload={(url) =>
                //   setFormData((prev) => ({ ...prev, images: url }))
                // }
              />
            </div>
            <div className="col-12">
              <label className="form-label"> {t("console.plant.form_upload_image_description")} </label>
              <textarea
                name="description"
                className="form-control"
                rows={8}
                value={formData.description}
                onChange={handleChange}
              />
            </div>



<div className="col-12">
  <label className="form-label">  {t("console.plant.watering.watering_title")}   </label>

  {formData.watering.map((item, index) => (
    <div key={index} className="border rounded p-3 mb-3 bg-light">
      <div className="row g-2">
        <div className="col-md-2">
          <label className="form-label"> {t("console.plant.watering.season")}   </label>
          <select
            className="form-select"
            value={item.season}
            onChange={(e) => handleWateringChange(index, "season", e.target.value)}
          >
            <option value="spring"> {t("console.plant.watering.season_spring")}   </option>
            <option value="summer"> {t("console.plant.watering.season_summer")}   </option>
            <option value="fall">  {t("console.plant.watering.season_fall")}  </option>
            <option value="winter"> {t("console.plant.watering.season_winter")}  </option>
          </select>
        </div>
        <div className="col-md-2">
          <label className="form-label">    {t("console.plant.watering.recurring_type_title")}     </label>
          <select
            className="form-select"
            value={item.frequencyType}
            onChange={(e) => handleWateringChange(index, "frequencyType", e.target.value)}
          >
            <option value="daily">    {t("console.plant.watering.recurring_type_daily")}      </option>
            <option value="everyXDays">    {t("console.plant.watering.recurring_type_multiPerX")}     </option>
          </select>
        </div>
        {item.frequencyType === "everyXDays" && (
          <div className="col-md-2">
            <label className="form-label">  {t("console.plant.watering.intervalDays")}   </label>
            <input
              type="number"
              className="form-control"
              value={item.intervalDays || ""}
              onChange={(e) => handleWateringChange(index, "intervalDays", Number(e.target.value))}
            />
          </div>
        )}
        <div className="col-md-2">
          <label className="form-label">    {t("console.plant.watering.timesPerDay")}       </label>
          <input
            type="number"
            className="form-control"
            value={item.timesPerDay}
            onChange={(e) => handleWateringChange(index, "timesPerDay", Number(e.target.value))}
          />
        </div>
        <div className="col-md-2">
          <label className="form-label"> {t("console.plant.watering.potSize_title")}    </label>
          <select
            className="form-select"
            value={item.potSize}
            onChange={(e) => handleWateringChange(index, "potSize", e.target.value)}
          >
            <option value="xsmall">   {t("console.plant.watering.potSize_xsmall")}       </option>
            <option value="small">   {t("console.plant.watering.potSize_small")}        </option>
            <option value="medium">  {t("console.plant.watering.potSize_medium")}        </option>
            <option value="large">    {t("console.plant.watering.potSize_large")}         </option>
            <option value="xlarge">   {t("console.plant.watering.potSize_xlarge")}        </option>
          </select>
        </div>
        <div className="col-md-2">
          <label className="form-label">   {t("console.plant.watering.requiredLight_duration_hours")}       </label>
          <input
            type="text"
            className="form-control"
            placeholder="مثلا ۵ تا ۶ ساعت"
            value={item.requiredLight?.duration_hours || ""}
            onChange={(e) =>
              handleNestedChange(index, "requiredLight", "duration_hours", e.target.value)
            }
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">   {t("console.plant.watering.requiredLight_type")}    </label>
          <select
            className="form-select"
            value={item.requiredLight?.type || ""}
            onChange={(e) =>
              handleNestedChange(index, "requiredLight", "type", e.target.value)
            }
          >
            <option value="DIRECT_HIGH">   {t("console.plant.watering.requiredLight_direct_hight")}     </option>
            <option value="INDIRECT_HIGH">  {t("console.plant.watering.requiredLight_indirect_hight")}     </option>
            <option value="INDIRECT_MEDIUM"> {t("console.plant.watering.requiredLight_indirect_medium")}     </option>
            <option value="INDIRECT_MEDIUM_HIGH">  {t("console.plant.watering.requiredLight_indirect_medium_hight")}      </option>
          </select>
        </div>
        <div className="col-md-3">
          <label className="form-label">   {t("console.plant.watering.watering_amountPerTime")}      (ml)</label>
          <input
            type="text"
            className="form-control"
            value={item.amountPerTime }
            onChange={(e) => handleAmountChange(index, e.target.value)}
            placeholder=''
          />
        </div>
        <div className="col-md-1 d-flex align-items-end">
          <button
            type="button"
            className="btn btn-danger btn-sm"
            onClick={() => removeWatering(index)}
          >
             {t("console.plant.watering.watering_remove_row")}  
          </button>
        </div>
      </div>
    </div>
  ))}

  <br/>
  <button type="button" className="btn btn-success btn-sm" onClick={addWatering}>
    + افزودن آبیاری
  </button>
</div>




            <div className="col-md-6">
              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="isActive"
                  checked={formData.isActive}
                  onChange={handleChange}
                />
                <label className="form-check-label">{t("console.plant.form_is_active")}</label>
              </div>
            </div>
            <div className="col-md-6 text-end mt-3">
              <button type="submit" className="btn btn-primary">
                <FaPlus className="me-2" />
                {isEditMode ? t("console.plant.form_submit_button_update_label") : t("console.plant.form_submit_button_create_label")}
              </button>
              {isEditMode && (
                <button
                  type="button"
                  className="btn btn-secondary ms-2"
                  onClick={resetForm}
                >
                  {t("console.plant.form_submit_button_cancel_edit_label")}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>

      <h4 className="mb-3">{t("console.plant.form_table_title")}</h4>
      <div className="table-responsive shadow-sm">
        <table className="table table-striped table-bordered">
          <thead className="table-light">
            <tr>
              <th>{t("console.plant.form_table_columns.name")}</th>
              <th>{t("console.plant.form_table_columns.language")}</th>
              <th>{t("console.plant.form_table_columns.image")}</th>
              <th>{t("console.plant.form_table_columns.description")}</th>
              <th>{t("console.plant.form_table_columns.active")}</th>
              <th>{t("console.plant.form_table_columns.groupName")}</th>
              <th>{t("console.plant.form_table_columns.createdAt")}</th>
              <th>{t("console.plant.form_table_columns.waterings")}</th>
              <th>{t("console.plant.form_table_columns.action")}</th>
            </tr>
          </thead>
          <tbody>
            {plants.map((plant) => (
              <tr key={plant._id}>
                <td>{plant.name}</td>
                <td><span style={{ fontSize: '24px' }}><LanguageFlag language={plant.language} /></span></td>
                <td>{plant.images?.[0]?.url ? <img src={BASE_URL + plant.images[0].url} alt='preview' width={64} /> : '-'}</td>
                <td>
                    <ExpandableDescription text={plant.description}/>
                </td>
                <td>
                  <span className={`badge bg-${plant.isActive ? "success" : "secondary"}`}>
                    {plant.isActive ? "Active" : "Inactive"}
                  </span>
                </td>

                <td>
                   {plant.group.name}
                </td>

                <td>{new Date(plant.createdAt).toLocaleDateString()}</td>
                <td>{plant.watering?.length || 0}  </td>

                <td>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handleEdit(plant)}
                  >
                    <FaEdit className="me-1" /> {t("console.plant.edit_btn_label")}
                  </button>
                </td>
              </tr>
            ))}
            {plants.length === 0 && (
              <tr>
                <td colSpan="7" className="text-center text-muted">
                  {t("console.plant.table_no_data")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlantAdmin;